import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * "Updated": someone else changed this record since you last opened it
 * (user, 2026-11-03; contracts `seen.ts`). Shared by every module's lists.
 */
export function ChangedBadge({ className = "" }: { className?: string }) {
	const { t } = useTranslation("common");
	return (
		<span
			title={t("changed.hint")}
			className={`inline-flex h-[1.125rem] items-center gap-[0.25rem] rounded-[0.25rem] bg-gms-warn-soft px-[0.375rem] text-[0.65625rem] font-semibold text-gms-warn ${className}`}
		>
			<span aria-hidden className="size-[0.375rem] rounded-full bg-gms-warn" />
			{t("changed.badge")}
		</span>
	);
}

/** The same fact on a record's own page, above its details. */
export function ChangedNote({ children }: { children?: ReactNode }) {
	const { t } = useTranslation("common");
	return (
		<p role="status" className="flex flex-wrap items-center gap-[0.5rem] rounded-[0.5rem] bg-gms-warn-soft px-[0.875rem] py-[0.5rem] text-[0.8125rem] text-gms-warn">
			<span aria-hidden className="size-[0.5rem] rounded-full bg-gms-warn" />
			<b className="font-semibold">{t("changed.note")}</b>
			{children}
		</p>
	);
}
